import styled from 'styled-components';
import spacing from '../../../theme/shared/spacing';
var Section = styled.section.withConfig({
  displayName: "DoubleCopystyle__Section",
  componentId: "sc-1kf782d-0"
})(["width:100%;@media ", "{display:flex;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint('small');
});
var CopyWrapper = styled.div.withConfig({
  displayName: "DoubleCopystyle__CopyWrapper",
  componentId: "sc-1kf782d-1"
})(["display:flex;padding:", ";"], spacing('xl'));
export { Section, CopyWrapper };